import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "messaging"
    }}>{`Messaging`}</h1>
    <p>{`These are the guidelines and best practices on when and how to provide users with feedback as they interact with your plugin.`}</p>
    <ul>
      <li parentName="ul">{`Alerts`}</li>
      <li parentName="ul">{`Success`}</li>
      <li parentName="ul">{`Output`}</li>
      <li parentName="ul">{`Permission dialogs`}</li>
      <li parentName="ul">{`Loaders and Progress Indicators`}</li>
      <li parentName="ul">{`Examples`}</li>
    </ul>
    <p>{`Provide users with feedback as they interact with your plugin. This can be alert and success messaging, permission dialogs, or loaders or progress bars to let them know that something is running in the background. `}</p>
    <p>{`Here is a guide to help you determine where to render plugin messages:`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "98.75%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/2022/static/63f9958680b56bccd382d221a18ade72/5530d/Messaging-1.webp 320w", "/photoshop/uxp/2022/static/63f9958680b56bccd382d221a18ade72/0c8fb/Messaging-1.webp 640w", "/photoshop/uxp/2022/static/63f9958680b56bccd382d221a18ade72/94b1e/Messaging-1.webp 1280w", "/photoshop/uxp/2022/static/63f9958680b56bccd382d221a18ade72/0b34d/Messaging-1.webp 1920w", "/photoshop/uxp/2022/static/63f9958680b56bccd382d221a18ade72/9acb0/Messaging-1.webp 2490w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/2022/static/63f9958680b56bccd382d221a18ade72/dd4a7/Messaging-1.png 320w", "/photoshop/uxp/2022/static/63f9958680b56bccd382d221a18ade72/0f09e/Messaging-1.png 640w", "/photoshop/uxp/2022/static/63f9958680b56bccd382d221a18ade72/bbbf7/Messaging-1.png 1280w", "/photoshop/uxp/2022/static/63f9958680b56bccd382d221a18ade72/ac7a9/Messaging-1.png 1920w", "/photoshop/uxp/2022/static/63f9958680b56bccd382d221a18ade72/369c0/Messaging-1.png 2490w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/photoshop/uxp/2022/static/63f9958680b56bccd382d221a18ade72/bbbf7/Messaging-1.png",
            "alt": "This shows the different ways you can provide feedback to the user through messaging",
            "title": "This shows the different ways you can provide feedback to the user through messaging",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <p>{`Open this image in a new tab in your browser in order to zoom in on it.`}</p>
    <h2 {...{
      "id": "alerts"
    }}>{`Alerts`}</h2>
    <p><strong parentName="p">{`Use case`}</strong><br parentName="p"></br>{`
`}{`Use alert messaging whenever the plugin cannot perform the intended task, dialogs are persistent until dismissed`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "54.0625%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/2022/static/09f217d388e1be5ba93320d670efe41a/5530d/Alert-Requirements.webp 320w", "/photoshop/uxp/2022/static/09f217d388e1be5ba93320d670efe41a/0c8fb/Alert-Requirements.webp 640w", "/photoshop/uxp/2022/static/09f217d388e1be5ba93320d670efe41a/94b1e/Alert-Requirements.webp 1280w", "/photoshop/uxp/2022/static/09f217d388e1be5ba93320d670efe41a/0b34d/Alert-Requirements.webp 1920w", "/photoshop/uxp/2022/static/09f217d388e1be5ba93320d670efe41a/9acb0/Alert-Requirements.webp 2490w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/2022/static/09f217d388e1be5ba93320d670efe41a/dd4a7/Alert-Requirements.png 320w", "/photoshop/uxp/2022/static/09f217d388e1be5ba93320d670efe41a/0f09e/Alert-Requirements.png 640w", "/photoshop/uxp/2022/static/09f217d388e1be5ba93320d670efe41a/bbbf7/Alert-Requirements.png 1280w", "/photoshop/uxp/2022/static/09f217d388e1be5ba93320d670efe41a/ac7a9/Alert-Requirements.png 1920w", "/photoshop/uxp/2022/static/09f217d388e1be5ba93320d670efe41a/369c0/Alert-Requirements.png 2490w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/photoshop/uxp/2022/static/09f217d388e1be5ba93320d670efe41a/bbbf7/Alert-Requirements.png",
            "alt": "This shows the alert dialog requirements",
            "title": "This shows the alert dialog requirements",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h4 {...{
      "id": "ux-requirements"
    }}>{`UX requirements`}</h4>
    <p><strong parentName="p">{`Header`}</strong><br parentName="p"></br>{`
`}{`Have a clear header that describes the error`}</p>
    <p><strong parentName="p">{`Message`}</strong><br parentName="p"></br>{`
`}{`Explain what error was encountered and give a clear actionable solution. Also, avoid blaming the user or the application.`}</p>
    <p><strong parentName="p">{`Dialog buttons`}</strong><br parentName="p"></br>{`
`}{`Include at least one modal dismissal button to allow the user to dismiss/close the modal`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "54.0625%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/2022/static/9fd378fbbae406be9024512c75f7f145/5530d/Alert-Recommendations.webp 320w", "/photoshop/uxp/2022/static/9fd378fbbae406be9024512c75f7f145/0c8fb/Alert-Recommendations.webp 640w", "/photoshop/uxp/2022/static/9fd378fbbae406be9024512c75f7f145/94b1e/Alert-Recommendations.webp 1280w", "/photoshop/uxp/2022/static/9fd378fbbae406be9024512c75f7f145/0b34d/Alert-Recommendations.webp 1920w", "/photoshop/uxp/2022/static/9fd378fbbae406be9024512c75f7f145/9acb0/Alert-Recommendations.webp 2490w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/2022/static/9fd378fbbae406be9024512c75f7f145/dd4a7/Alert-Recommendations.png 320w", "/photoshop/uxp/2022/static/9fd378fbbae406be9024512c75f7f145/0f09e/Alert-Recommendations.png 640w", "/photoshop/uxp/2022/static/9fd378fbbae406be9024512c75f7f145/bbbf7/Alert-Recommendations.png 1280w", "/photoshop/uxp/2022/static/9fd378fbbae406be9024512c75f7f145/ac7a9/Alert-Recommendations.png 1920w", "/photoshop/uxp/2022/static/9fd378fbbae406be9024512c75f7f145/369c0/Alert-Recommendations.png 2490w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/photoshop/uxp/2022/static/9fd378fbbae406be9024512c75f7f145/bbbf7/Alert-Recommendations.png",
            "alt": "This shows the alert dialog best practices",
            "title": "This shows the alert dialog best practices",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h4 {...{
      "id": "best-practices"
    }}>{`Best practices`}</h4>
    <p><strong parentName="p">{`Warning icon`}</strong><br parentName="p"></br>{`
`}{`To help communicate critical information for an error you can include a warning icon next to the header`}</p>
    <p><strong parentName="p">{`Help`}</strong><br parentName="p"></br>{`
`}{`If a plugin has a help page, consider adding it to the error modal dialog.`}</p>
    <p><strong parentName="p">{`Visual/tutorials`}</strong><br parentName="p"></br>{`
`}{`Provide image/GIF example as part of the dialog, to help users understand the actionable solution`}</p>
    <p><strong parentName="p">{`Messaging`}</strong><br parentName="p"></br>{`
`}{`In the alert messages use language that is easy to understand for the user.`}</p>
    <h2 {...{
      "id": "success"
    }}>{`Success`}</h2>
    <p><strong parentName="p">{`Use case`}</strong><br parentName="p"></br>{`
`}{`Use success messaging whenever the plugin successfully completes a task and has no visual output on the canvas.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "54.0625%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/2022/static/db95d2e3d2ebea4badf662a7657ade6c/5530d/success-Requirements.webp 320w", "/photoshop/uxp/2022/static/db95d2e3d2ebea4badf662a7657ade6c/0c8fb/success-Requirements.webp 640w", "/photoshop/uxp/2022/static/db95d2e3d2ebea4badf662a7657ade6c/94b1e/success-Requirements.webp 1280w", "/photoshop/uxp/2022/static/db95d2e3d2ebea4badf662a7657ade6c/0b34d/success-Requirements.webp 1920w", "/photoshop/uxp/2022/static/db95d2e3d2ebea4badf662a7657ade6c/9acb0/success-Requirements.webp 2490w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/2022/static/db95d2e3d2ebea4badf662a7657ade6c/dd4a7/success-Requirements.png 320w", "/photoshop/uxp/2022/static/db95d2e3d2ebea4badf662a7657ade6c/0f09e/success-Requirements.png 640w", "/photoshop/uxp/2022/static/db95d2e3d2ebea4badf662a7657ade6c/bbbf7/success-Requirements.png 1280w", "/photoshop/uxp/2022/static/db95d2e3d2ebea4badf662a7657ade6c/ac7a9/success-Requirements.png 1920w", "/photoshop/uxp/2022/static/db95d2e3d2ebea4badf662a7657ade6c/369c0/success-Requirements.png 2490w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/photoshop/uxp/2022/static/db95d2e3d2ebea4badf662a7657ade6c/bbbf7/success-Requirements.png",
            "alt": "This shows the alert success dialog example",
            "title": "This shows the alert success dialog example",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h4 {...{
      "id": "ux-requirements-1"
    }}>{`UX requirements`}</h4>
    <p><strong parentName="p">{`Header`}</strong><br parentName="p"></br>{`
`}{`Have a clear header for the dialog.`}</p>
    <p><strong parentName="p">{`Message`}</strong><br parentName="p"></br>{`
`}{`Explain what the plugin successfully completed, if it is not visually apparent to the user.`}</p>
    <p><strong parentName="p">{`Dialog buttons`}</strong><br parentName="p"></br>{`
`}{`Include at least one modal dismissal button to allow the user to dismiss/close the modal.`}</p>
    <h2 {...{
      "id": "output"
    }}>{`Output`}</h2>
    <p><strong parentName="p">{`Use case`}</strong><br parentName="p"></br>{`
`}{`If a plugin generates output that the user needs to complete a workflow, then the plugin needs to provide that information to the user through an interface.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "83.75%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/2022/static/70d612f69ceedf205995fcd6b321ca81/5530d/Plugin-output.webp 320w", "/photoshop/uxp/2022/static/70d612f69ceedf205995fcd6b321ca81/0c8fb/Plugin-output.webp 640w", "/photoshop/uxp/2022/static/70d612f69ceedf205995fcd6b321ca81/94b1e/Plugin-output.webp 1280w", "/photoshop/uxp/2022/static/70d612f69ceedf205995fcd6b321ca81/0b34d/Plugin-output.webp 1920w", "/photoshop/uxp/2022/static/70d612f69ceedf205995fcd6b321ca81/9acb0/Plugin-output.webp 2490w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/2022/static/70d612f69ceedf205995fcd6b321ca81/dd4a7/Plugin-output.png 320w", "/photoshop/uxp/2022/static/70d612f69ceedf205995fcd6b321ca81/0f09e/Plugin-output.png 640w", "/photoshop/uxp/2022/static/70d612f69ceedf205995fcd6b321ca81/bbbf7/Plugin-output.png 1280w", "/photoshop/uxp/2022/static/70d612f69ceedf205995fcd6b321ca81/ac7a9/Plugin-output.png 1920w", "/photoshop/uxp/2022/static/70d612f69ceedf205995fcd6b321ca81/369c0/Plugin-output.png 2490w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/photoshop/uxp/2022/static/70d612f69ceedf205995fcd6b321ca81/bbbf7/Plugin-output.png",
            "alt": "This shows the plugin output example",
            "title": "This shows the plugin output example",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h4 {...{
      "id": "ux-requirements-2"
    }}>{`UX requirements`}</h4>
    <p><strong parentName="p">{`Plugin output`}</strong><br parentName="p"></br>{`
`}{`In use cases like these, the plugin output can be shown in the interface, copied onto the clipboard, populated on the document or generate a file.`}</p>
    <p><strong parentName="p">{`Example:`}</strong><br parentName="p"></br>{`
`}{`Copied onto the clipboard - the plugin can add copy to the clipboard and provides the user with instructions through the interface.`}</p>
    <p><strong parentName="p">{`Don’t`}</strong><br parentName="p"></br>{`
`}{`Require users to go into the developer console to complete an action.`}</p>
    <h2 {...{
      "id": "permission-dialogs"
    }}>{`Permission dialogs`}</h2>
    <p><strong parentName="p">{`Use case`}</strong><br parentName="p"></br>{`
`}{`Use permission dialogs when being destructive or making modifications.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "54.0625%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/2022/static/07b7d018cc085d098aaeb5fad1dc8d71/5530d/Permission-dialog-example.webp 320w", "/photoshop/uxp/2022/static/07b7d018cc085d098aaeb5fad1dc8d71/0c8fb/Permission-dialog-example.webp 640w", "/photoshop/uxp/2022/static/07b7d018cc085d098aaeb5fad1dc8d71/94b1e/Permission-dialog-example.webp 1280w", "/photoshop/uxp/2022/static/07b7d018cc085d098aaeb5fad1dc8d71/0b34d/Permission-dialog-example.webp 1920w", "/photoshop/uxp/2022/static/07b7d018cc085d098aaeb5fad1dc8d71/9acb0/Permission-dialog-example.webp 2490w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/2022/static/07b7d018cc085d098aaeb5fad1dc8d71/dd4a7/Permission-dialog-example.png 320w", "/photoshop/uxp/2022/static/07b7d018cc085d098aaeb5fad1dc8d71/0f09e/Permission-dialog-example.png 640w", "/photoshop/uxp/2022/static/07b7d018cc085d098aaeb5fad1dc8d71/bbbf7/Permission-dialog-example.png 1280w", "/photoshop/uxp/2022/static/07b7d018cc085d098aaeb5fad1dc8d71/ac7a9/Permission-dialog-example.png 1920w", "/photoshop/uxp/2022/static/07b7d018cc085d098aaeb5fad1dc8d71/369c0/Permission-dialog-example.png 2490w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/photoshop/uxp/2022/static/07b7d018cc085d098aaeb5fad1dc8d71/bbbf7/Permission-dialog-example.png",
            "alt": "This shows a permission dialog example",
            "title": "This shows a permission dialog example",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h4 {...{
      "id": "ux-requirements-3"
    }}>{`UX requirements`}</h4>
    <p><strong parentName="p">{`Header`}</strong><br parentName="p"></br>{`
`}{`Have a clear header for the dialog.`}</p>
    <p><strong parentName="p">{`Message`}</strong><br parentName="p"></br>{`
`}{`Explain the destructive action or modification and ask for the user’s permission`}</p>
    <p><strong parentName="p">{`Dialog buttons`}</strong><br parentName="p"></br>{`
`}{`Include a modal dismissal button to allow the user to cancel/close the modal and a negative button (red) to highlight that action.`}</p>
    <p><strong parentName="p">{`Key Commands`}</strong><br parentName="p"></br>{`
`}{`Esc key or Enter key Dismisses the dialog when the “Cancel” button is in focus`}</p>
    <h2 {...{
      "id": "loaders-and-progress-indicators"
    }}>{`Loaders and Progress Indicators`}</h2>
    <p>{`Let the user know when something is happening in the background in the plugin interface. `}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "54.0625%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/2022/static/cb2230b02eaac062817050a01daa037a/5530d/progress-bar-example.webp 320w", "/photoshop/uxp/2022/static/cb2230b02eaac062817050a01daa037a/0c8fb/progress-bar-example.webp 640w", "/photoshop/uxp/2022/static/cb2230b02eaac062817050a01daa037a/94b1e/progress-bar-example.webp 1280w", "/photoshop/uxp/2022/static/cb2230b02eaac062817050a01daa037a/0b34d/progress-bar-example.webp 1920w", "/photoshop/uxp/2022/static/cb2230b02eaac062817050a01daa037a/9acb0/progress-bar-example.webp 2490w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/2022/static/cb2230b02eaac062817050a01daa037a/dd4a7/progress-bar-example.png 320w", "/photoshop/uxp/2022/static/cb2230b02eaac062817050a01daa037a/0f09e/progress-bar-example.png 640w", "/photoshop/uxp/2022/static/cb2230b02eaac062817050a01daa037a/bbbf7/progress-bar-example.png 1280w", "/photoshop/uxp/2022/static/cb2230b02eaac062817050a01daa037a/ac7a9/progress-bar-example.png 1920w", "/photoshop/uxp/2022/static/cb2230b02eaac062817050a01daa037a/369c0/progress-bar-example.png 2490w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/photoshop/uxp/2022/static/cb2230b02eaac062817050a01daa037a/bbbf7/progress-bar-example.png",
            "alt": "This shows a progress bar example",
            "title": "This shows a progress bar example",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h4 {...{
      "id": "best-practices-1"
    }}>{`Best practices`}</h4>
    <p><strong parentName="p">{`Progress bar`}</strong><br parentName="p"></br>{`
`}{`Progress bars show the progression of a system operation: downloading, uploading, processing, etc., in a visual way. They can represent either determinate or indeterminate progress.`}</p>
    <p><a parentName="p" {...{
        "href": "https://spectrum.adobe.com/page/progress-bar/"
      }}>{`Spectrum Progress bar guidelines`}</a></p>
    <p><strong parentName="p">{`Progress circle`}</strong><br parentName="p"></br>{`
`}{`Progress circles show the progression of a system operation such as downloading, uploading, processing, etc. in a visual way. They can represent determinate or indeterminate progress.`}</p>
    <p><a parentName="p" {...{
        "href": "https://spectrum.adobe.com/page/progress-bar/"
      }}>{`Spectrum Progress circle guidelines`}</a></p>
    <h2 {...{
      "id": "examples"
    }}>{`Examples`}</h2>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "44.99999999999999%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/2022/static/4516eee133760022f585cdec8477f622/5530d/Error-alert-example.webp 320w", "/photoshop/uxp/2022/static/4516eee133760022f585cdec8477f622/0c8fb/Error-alert-example.webp 640w", "/photoshop/uxp/2022/static/4516eee133760022f585cdec8477f622/94b1e/Error-alert-example.webp 1280w", "/photoshop/uxp/2022/static/4516eee133760022f585cdec8477f622/0b34d/Error-alert-example.webp 1920w", "/photoshop/uxp/2022/static/4516eee133760022f585cdec8477f622/9acb0/Error-alert-example.webp 2490w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/2022/static/4516eee133760022f585cdec8477f622/dd4a7/Error-alert-example.png 320w", "/photoshop/uxp/2022/static/4516eee133760022f585cdec8477f622/0f09e/Error-alert-example.png 640w", "/photoshop/uxp/2022/static/4516eee133760022f585cdec8477f622/bbbf7/Error-alert-example.png 1280w", "/photoshop/uxp/2022/static/4516eee133760022f585cdec8477f622/ac7a9/Error-alert-example.png 1920w", "/photoshop/uxp/2022/static/4516eee133760022f585cdec8477f622/369c0/Error-alert-example.png 2490w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/photoshop/uxp/2022/static/4516eee133760022f585cdec8477f622/bbbf7/Error-alert-example.png",
            "alt": "This shows an alert example for an operation that failed to complete",
            "title": "This shows an alert example for an operation that failed to complete",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <p><strong parentName="p">{`Operation failed to complete`}</strong><br parentName="p"></br>{`
`}{`Error dialog - when a plugin can’t complete an operation, render an error dialog to let the user know the operation failed and why it failed.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "44.99999999999999%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/2022/static/8246932a2e2718c7dba4178ea08a92dd/5530d/Alert-Information-example-2.webp 320w", "/photoshop/uxp/2022/static/8246932a2e2718c7dba4178ea08a92dd/0c8fb/Alert-Information-example-2.webp 640w", "/photoshop/uxp/2022/static/8246932a2e2718c7dba4178ea08a92dd/94b1e/Alert-Information-example-2.webp 1280w", "/photoshop/uxp/2022/static/8246932a2e2718c7dba4178ea08a92dd/0b34d/Alert-Information-example-2.webp 1920w", "/photoshop/uxp/2022/static/8246932a2e2718c7dba4178ea08a92dd/9acb0/Alert-Information-example-2.webp 2490w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/2022/static/8246932a2e2718c7dba4178ea08a92dd/dd4a7/Alert-Information-example-2.png 320w", "/photoshop/uxp/2022/static/8246932a2e2718c7dba4178ea08a92dd/0f09e/Alert-Information-example-2.png 640w", "/photoshop/uxp/2022/static/8246932a2e2718c7dba4178ea08a92dd/bbbf7/Alert-Information-example-2.png 1280w", "/photoshop/uxp/2022/static/8246932a2e2718c7dba4178ea08a92dd/ac7a9/Alert-Information-example-2.png 1920w", "/photoshop/uxp/2022/static/8246932a2e2718c7dba4178ea08a92dd/369c0/Alert-Information-example-2.png 2490w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/photoshop/uxp/2022/static/8246932a2e2718c7dba4178ea08a92dd/bbbf7/Alert-Information-example-2.png",
            "alt": "This shows an alert example for a network connectivity issue",
            "title": "This shows an alert example for a network connectivity issue",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <p><strong parentName="p">{`Network connectivity issue`}</strong><br parentName="p"></br>{`
`}{`Information dialog - if the plugin is unable to connect to the internet to complete an action, then use an information modal dialog to communicate that to the user.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "44.99999999999999%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/2022/static/72ecc3d5371f5e3f379216817d650c67/5530d/Messaging-example.webp 320w", "/photoshop/uxp/2022/static/72ecc3d5371f5e3f379216817d650c67/0c8fb/Messaging-example.webp 640w", "/photoshop/uxp/2022/static/72ecc3d5371f5e3f379216817d650c67/94b1e/Messaging-example.webp 1280w", "/photoshop/uxp/2022/static/72ecc3d5371f5e3f379216817d650c67/0b34d/Messaging-example.webp 1920w", "/photoshop/uxp/2022/static/72ecc3d5371f5e3f379216817d650c67/9acb0/Messaging-example.webp 2490w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/2022/static/72ecc3d5371f5e3f379216817d650c67/dd4a7/Messaging-example.png 320w", "/photoshop/uxp/2022/static/72ecc3d5371f5e3f379216817d650c67/0f09e/Messaging-example.png 640w", "/photoshop/uxp/2022/static/72ecc3d5371f5e3f379216817d650c67/bbbf7/Messaging-example.png 1280w", "/photoshop/uxp/2022/static/72ecc3d5371f5e3f379216817d650c67/ac7a9/Messaging-example.png 1920w", "/photoshop/uxp/2022/static/72ecc3d5371f5e3f379216817d650c67/369c0/Messaging-example.png 2490w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/photoshop/uxp/2022/static/72ecc3d5371f5e3f379216817d650c67/bbbf7/Messaging-example.png",
            "alt": "This shows a message example",
            "title": "This shows a message example",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <p><strong parentName="p">{`Unable to share`}</strong><br parentName="p"></br>{`
`}{`“An error occurred while sharing your project. Please verify the email. address and try again”.`}</p>
    <p><strong parentName="p">{`Network connectivity`}</strong><br parentName="p"></br>{`
`}{`“Please connect to WiFi to sync your tasks to your product management tool”.`}</p>
    <h4 {...{
      "id": "panel-ui-messaging"
    }}>{`Panel UI messaging`}</h4>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "71.5625%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/2022/static/707dd0846fcc82d1a646838c8dcab03c/5530d/panel-messaging-example.webp 320w", "/photoshop/uxp/2022/static/707dd0846fcc82d1a646838c8dcab03c/0c8fb/panel-messaging-example.webp 640w", "/photoshop/uxp/2022/static/707dd0846fcc82d1a646838c8dcab03c/94b1e/panel-messaging-example.webp 1280w", "/photoshop/uxp/2022/static/707dd0846fcc82d1a646838c8dcab03c/0b34d/panel-messaging-example.webp 1920w", "/photoshop/uxp/2022/static/707dd0846fcc82d1a646838c8dcab03c/9acb0/panel-messaging-example.webp 2490w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/2022/static/707dd0846fcc82d1a646838c8dcab03c/dd4a7/panel-messaging-example.png 320w", "/photoshop/uxp/2022/static/707dd0846fcc82d1a646838c8dcab03c/0f09e/panel-messaging-example.png 640w", "/photoshop/uxp/2022/static/707dd0846fcc82d1a646838c8dcab03c/bbbf7/panel-messaging-example.png 1280w", "/photoshop/uxp/2022/static/707dd0846fcc82d1a646838c8dcab03c/ac7a9/panel-messaging-example.png 1920w", "/photoshop/uxp/2022/static/707dd0846fcc82d1a646838c8dcab03c/369c0/panel-messaging-example.png 2490w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/photoshop/uxp/2022/static/707dd0846fcc82d1a646838c8dcab03c/bbbf7/panel-messaging-example.png",
            "alt": "This shows a panel messaging example",
            "title": "This shows a panel messaging example",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      